var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sql-editor-wrapper" },
    [
      _c("codemirror", {
        ref: "cmEditor",
        attrs: { options: _vm.editorOptions },
        on: {
          input: _vm.handleInput,
          ready: _vm.handleReady,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur
        },
        model: {
          value: _vm.currentValue,
          callback: function($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }